import * as React from "react";
import Overlay from "@/ReactComponents/Overlay/overlay";

const OverlayView = props => <Overlay {...props} />;

export default OverlayView;
